import React, { useEffect, useRef, useState } from "react";
import { ClipLoader } from "react-spinners";
import { toast } from "../../utils/toast";

import { api } from "../../api/api";
import LetterDialog, {
  LetterDialogActions,
  letterModalBodyClass,
} from "../UX/LetterDialog";

function TitleModal({
  open = true,
  onClose,
  onFinish,
  isEditing,
  id,
  onTypingChange,
}) {
  const titleRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState("");

  useEffect(() => {
    if (!open || !isEditing) return;
    setIsLoading(true);
    api
      .get(`letter/${id}`)
      .then((res) => {
        setData(res.data.letter.title);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, [open, isEditing, id]);

  const finishHandler = () => {
    const title = titleRef.current.value;
    if (title.trim().length === 0) {
      toast.error("Entrez un titre valide");
      return;
    }
    onFinish(title);
  };

  return (
    <LetterDialog
      open={open}
      onClose={onClose}
      animationVariant="scaleFade"
      title="Modifier le titre"
      footer={
        !isLoading && (
          <LetterDialogActions
            secondaryLabel="Fermer"
            onSecondary={onClose}
            secondaryVariant="outline"
            primaryLabel="Terminer"
            onPrimary={finishHandler}
            primaryVariant="purple"
          />
        )
      }
    >
      {isLoading ? (
        <div className="flex justify-center py-8">
          <ClipLoader color="#823779" size={32} />
        </div>
      ) : (
        <>
          <input
            ref={titleRef}
            id="letterTitle"
            maxLength={30}
            type="text"
            placeholder="Sans titre"
            defaultValue={data}
            onChange={() => onTypingChange?.(true)}
            className="mb-4 w-full rounded-md border border-greyLight bg-white p-3 font-josefin text-secondaryText outline-none focus:border-primaryText"
          />
          <p className={letterModalBodyClass}>
            Il ne sera pas connu des destinataires de la lettre.
          </p>
        </>
      )}
    </LetterDialog>
  );
}

export default TitleModal;
